import { useEffect, useState } from 'react';
import { LeaderboardUserItem } from './LeaderboardItem/LeaderboardUserItem';
import { LeaderboardCommandItem } from './LeaderboardItem/LeaderboardCommandItem';
import { LeaderboardTabWrapper, LeaderboardTabItem } from './Leaderboard.styles';
import { useAppSelector } from 'src/App/redux/hooks';
import Authentication from 'src/App/Services/Authentication.service';
import { RootState } from 'src/App/redux/store';
import { LeaderboardPointsItem } from './LeaderboardItem/LeaderboardPointsItem';

enum LeaderboardTabs {
	USERS,
	COMMANDS,
	POINTS,
}

export function Leaderboard({ changeTitle }: { changeTitle: (title: string) => void }) {
	const extensions_id = useAppSelector((state: RootState) => state.app.extensions_id);
	const [tab, setTab] = useState(LeaderboardTabs.USERS);
	const [leaderboardStats, setLeaderboardStats] = useState({
		users: [],
		commands: [],
		pointUsers: [],
	});

	useEffect(() => {
		// Get Config
		Authentication.makeCall(`api/extension/public/leaderboard/${extensions_id}`)
			.then((leaderboardRes) => {
				const leaderboardData: any = leaderboardRes.data?.data;
				if (leaderboardData) {
					setLeaderboardStats({ users: leaderboardData?.users, commands: leaderboardData?.commands, pointUsers: leaderboardData?.pointUsers });
				}
			})
			.catch((err) => {
				console.error('Error getting configuration: ', err.response);
			});
	}, [extensions_id]);

	useEffect(() => {
		tab === LeaderboardTabs.USERS ? changeTitle('Rank higher by using more bits') : LeaderboardTabs.POINTS ? changeTitle('Rank higher by using more points') : changeTitle('The most used commands');
	}, [changeTitle, tab]);

	return (
		<>
			<LeaderboardTabWrapper>
				<LeaderboardTabItem selected={tab === LeaderboardTabs.USERS} onClick={() => setTab(LeaderboardTabs.USERS)}>
					Users
				</LeaderboardTabItem>
				<LeaderboardTabItem selected={tab === LeaderboardTabs.COMMANDS} onClick={() => setTab(LeaderboardTabs.COMMANDS)}>
					Commands
				</LeaderboardTabItem>
				{/* <LeaderboardTabItem selected={tab === LeaderboardTabs.POINTS} onClick={() => setTab(LeaderboardTabs.POINTS)}>
					Points
				</LeaderboardTabItem> */}
			</LeaderboardTabWrapper>
			{tab === LeaderboardTabs.USERS ? (
				<LeaderboardUserItem users={leaderboardStats.users} />
			) : tab === LeaderboardTabs.COMMANDS ? (
				<LeaderboardCommandItem commands={leaderboardStats.commands} />
			) : (
				<LeaderboardPointsItem users={leaderboardStats.pointUsers} />
			)}
		</>
	);
}
